// extracted by mini-css-extract-plugin
export var root = "AccountPageMenu-module--root--8t4LI";
export var divider = "AccountPageMenu-module--divider--gbPXN";
export var active = "AccountPageMenu-module--active--xiz1a";
export var user = "AccountPageMenu-module--user--b9NDF";